import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.scss';
import '../../styles/menu.scss';
import '../../styles/container.scss';

const quantMenus = [
  { label: '整体概览', path: 'overview' },
  { label: '回测', path: 'backtest' },
  { label: '参数配置', path: 'config' },
];

export default function Quant() {
  const navigate = useNavigate();
  const location = useLocation();
  const activePath = location.pathname.split('/')[2] || quantMenus[0].path;
  const activeMenu = quantMenus.find(m => m.path === activePath) || quantMenus[0];

  return (
    <div className="page_container">
      {/* 左侧菜单栏 */}
      <div className="menu_sidebar">
        {quantMenus.map(menu => (
          <div
            key={menu.path}
            onClick={() => navigate(`/quant/${menu.path}`)}
            className={`menu_item ${activePath === menu.path ? 'menu_item_active' : ''}`}
          >
            {menu.label}
          </div>
        ))}
      </div>
      {/* 右侧内容区 */}
      <div className="page_content_area">
        <h2 className="page_active_title">{activeMenu.label}</h2>
        <div className="page_content_placeholder">这里是「{activeMenu.label}」的内容区域。</div>
      </div>
    </div>
  );
} 